export default __webpack_public_path__ + "static/media/twitter.346e3b77.png";